import request from './index'

class login {
   static adminLogin(params){   //管理员登录
        return request('post', '/login/admin',params)
    }
    static teacherLogin(params){ //老师登录
        return request('post',"/login/teacher",params)
    }
    static sendcode(params){ //发送验证码
        return request('post','/sms/sendCode',params)
    }
   
} 
export default login